import {CSSProperties} from 'react';

const stepTitleStyle: CSSProperties = {
  display: 'block',
  fontWeight: 600,
  marginBottom: '0.5rem',
};

function getOnboardingTourSteps(hasInProgress: boolean, hasOpened: boolean) {
  const steps = [
    {
      selector: '[data-focusid="userInfo"]',
      content: (
        <>
          <b style={stepTitleStyle}>BEM-VINDO(A)! SEU GUIA RÁPIDO LETRUS</b>
          <p>
            Que bom ter você aqui! Este tour vai te ajudar a entender como
            funciona a plataforma e começar a escrever.
            <br />
            <b>Lembre-se:</b> anote e guarde seu login e senha em um local
            seguro. Cerca de 6 a cada 10 estudantes esquecem. A melhor dica é
            anotar em um lugar seguro. Assim, você entra rapidinho!
          </p>
        </>
      ),
    },
    {
      selector: '[data-focusid="logoutButton"]',
      content: (
        <>
          <b style={stepTitleStyle}>MUITO IMPORTANTE: CLIQUE AQUI SEMPRE!</b>
          <p>
            Se você estiver usando o computador da escola ou de um amigo, nunca
            esqueça de clicar em <b>&quot;Sair&quot;</b>!<br />
            Isso é essencial para proteger sua conta e garantir que só você
            tenha acesso às suas atividades. É rápido e super seguro!
          </p>
        </>
      ),
    },
    {
      selector: '[data-focusid="notificationBell"]',
      content: (
        <>
          <b style={stepTitleStyle}>DE OLHO NOS AVISOS (O SININHO!)</b>
          <p>
            O sininho te avisa de tudo que é importante! Ele acende quando tem
            devolutiva nova, uma recomendação do professor, ou uma nova
            atividade para você fazer.
            <br />É o jeito mais fácil de não perder nada!
          </p>
        </>
      ),
    },
    {
      selector: '[data-focusid="openActivities"]',
      content: (
        <>
          <b style={stepTitleStyle}>COMEÇANDO AGORA: ATIVIDADES ABERTAS</b>
          <p>
            Sua missão é aqui! As Atividades abertas são as tarefas que você
            precisa completar.
            <br />
            Veja as etapas (Questionário, Escrita, etc.) e use o botão{' '}
            <b>&quot;Iniciar atividade&quot;</b> ou <b>&quot;Continuar&quot;</b>{' '}
            para seguir de onde parou.
          </p>
        </>
      ),
    },
    {
      selector: '[data-focusid="scheduledOrPastActivities"]',
      content: (
        <>
          <b style={stepTitleStyle}>PRA FRENTE E PARA TRÁS!</b>
          <p>
            Descendo a página, você encontra as <b>Agendadas</b> (que ainda vão
            começar) e as <b>Passadas</b> (onde você vê a correção e nota
            final).
            <br />
            Assim, você consegue entender o que já passou e o que ainda está por
            vir.
          </p>
        </>
      ),
    },
  ];

  if (hasInProgress || hasOpened) {
    steps.push({
      selector: '[data-focusid="startActivityButton"]',
      content: (
        <>
          <b style={stepTitleStyle}>AGORA É COM VOCÊ!</b>
          <p>
            O foco é o agora! Clique em &quot;<b>Iniciar atividade</b>&quot;
            para começar sua primeira escrita. Concentre-se, dê o seu melhor e
            mande bem. Boa sorte!
          </p>
        </>
      ),
    });
  }

  return steps;
}
export {getOnboardingTourSteps};
